module.exports = "pegasus_template/assets/themecapture1/basic/101.png";